import cookies from 'browser-cookies';

/**
 * Normalizes user data
 * @param {Object} userData - WHX.data object
 * @returns {Object} standardized UserData object
 */
const normalizeData = ({
  obAvFlags = '',
  obClientName = '',
  obAccountNumber = '',
  obBalanceCurrency = '',
  obBalanceAmount = '',
  obMessageNumber = 0,
  obLastLogin = '',
  obFormAction = '',
  obFormHidden = '',
  obUsernameName = '',
  obPasswordName = '',
}) => ({
  obAvFlags,
  obClientName,
  obAccountNumber,
  obBalanceCurrency,
  obBalanceAmount,
  obMessageNumber,
  obLastLogin,
  obFormAction,
  obFormHidden,
  obUsernameName,
  obPasswordName,
});

/**
 * Parse user data for logged in/out user from Session CUST
 * @param {String} userData - response from endpoint
 * @returns {Object} standardized UserData object
 */
export default (userData) => {
  /* Unfortunately, getXLogin endpoint returns text/html response type with javascript code. */
  const WHX = {};

  try {
    eval(userData.replace('var', ''));
  } catch (ex) {
    console.error(`ERR_USERDTO_NOTVALIDDATA: ${userData}`);
  }

  WHX.authenticated = WHX.authenticated || false;

  const user = {
    isLoggedIn: WHX.authenticated.toString() === 'Y',
    cust: {
      auth: cookies.get('cust_auth'),
      login: cookies.get('cust_login'),
      sslLogin: cookies.get('cust_ssl_login'),
    },
  };

  if (WHX !== undefined && WHX.data !== undefined) {
    user.data = normalizeData(WHX.data);
  }

  return user;
};
